/**
 * Chart of Accounts Page
 */
import React from 'react';

const ChartOfAccountsPage = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Chart of Accounts</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Manage GL accounts</p>
    </div>
  );
};

export default ChartOfAccountsPage;
